import { react, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Image from 'mui-image';
import CircularProgress from '@mui/material/CircularProgress';
import TokenService from '../../services/TokenService';

function NotInServiceArea(props) {

    const [emailAddress, setEmailAddress] = useState('');
    const [formErrors, setFormErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isComplete, setisComplete] = useState(false);

    function validateEmail(value) {
        
        let errors = {};
        let hasErrors = false;

        if (emailAddress.trim() === '') {
            hasErrors = true;
            errors["EmailAddress"] = "Email cannot be empty";
        }

        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(String(emailAddress).toLowerCase())) {
            hasErrors = true;
            errors["EmailAddress"] = "Not a valid email";
        }

        setFormErrors(errors);
        return hasErrors;
    }

    function sendEmail() {

        if (validateEmail() === false) {
            console.log('sending email');

            let postData = {
                requestGuid: '',
                emailAddress: emailAddress
            }
            TokenService.post(postData, 'ZipcodeRequestUpdate', '')
                .then((response) => {
                    if (response !== null) {
                        response = response[Object.keys(response)[0]];
                        if (response.Result === "SUCCESS") {
                            setIsLoading(false);
                            setisComplete(true);
                        }
                    }
                })
                .catch((response) => {
                    if (response !== null) {
                        setIsLoading(false);
                        setisComplete(true);
                    }
                });

            setIsLoading(true);
        }
    }

    function buildLoadingPanel() {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="50px"
            >
                <CircularProgress color="secondary" />
            </Box>
        )

    }

    function buildCompletedPanel() {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="50px"
            >
                <div>Thank you - we will send you an email as soon as service begins in your area</div>
            </Box>
        )
    }

    let panel;
    if (isLoading) {
        panel = buildLoadingPanel();
    }
    else if (isComplete)
    {
        panel = buildCompletedPanel();
    }
    else {
        panel = <div>
            <Box display="flex"
                justifyContent="center"
                alignItems="center"
                noValidate
                autoComplete="off">
                <Image src="images/Michigan.png" width={100} height={100} />
            </Box>
            <div style={{ marginTop: '10px' }}>
                If you would like to be notified when service is available in your area, please provide us with you email address
            </div>
            <Box display="flex"
                justifyContent="center"
                alignItems="center"
                noValidate
                marginTop="30px"
                autoComplete="off">
                <Stack direction="column">
                    <Stack spacing={2} direction="column">
                        <TextField error={formErrors['EmailAddress'] !== undefined} label="Email Address" onChange={(e) => setEmailAddress(e.target.value)} value={emailAddress} variant="outlined" style={{ maxWidth: '200px' }} />
                        <Button variant="contained" color="sipzeeYellow" style={{ fontSize: '8pt', fontWeight: 'bold' }} onClick={sendEmail}>Notify Me</Button>
                    </Stack>
                    <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formErrors["EmailAddress"]}</div>
                </Stack>
            </Box>
        </div>
    }

    return (panel);
      
  
}

export default NotInServiceArea;